// import lib
import { lazy } from "react";

const routes = [
  {
    role: "ROLE_FULLFILLMENT_CENTER",

    path: "/",
    element: lazy(() => import("../pages/SignIn")),
  },
];

export default routes;
